import { HttpErrorResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';

export interface RuntimeErrorMonitoringEvent {
  source: 'global-error-handler';
  timestamp: string;
}

export interface NetworkErrorMonitoringEvent {
  source: 'http-interceptor';
  method: string;
  url: string;
  statusCode: number;
  timestamp: string;
}

@Injectable({
  providedIn: 'root',
})
export class ErrorMonitoringService {
  captureRuntimeError(
    event: RuntimeErrorMonitoringEvent,
    error: unknown,
  ): void {
    console.error('runtime.error', {
      ...event,
      error,
    });
  }

  captureNetworkError(
    event: NetworkErrorMonitoringEvent,
    error: HttpErrorResponse,
  ): void {
    console.error('network.error', {
      ...event,
      statusCode: error.status,
      statusText: error.statusText,
      message: error.message,
    });
  }
}
